import React from 'react';
import styled from 'styled-components';

import { SearchInput } from '../../components';
import { useTranslation } from 'react-i18next';

const Container = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    flexDirection: ['column'],
    justifyContent: ['center'],
    width: '100%',
  })
);

const InputWrapper = styled.div(() => ({
  transition: 'all 1.5s ease',
}));

export const NavSearch = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <InputWrapper>
        <SearchInput
          placeholder={t('Search by name, public key, hash, uref or CSPR.name')}
          top={[48]}
          width={['100%']}
        />
      </InputWrapper>
    </Container>
  );
};
